const copyLinkIcon = document.querySelector('.social-share .social-share__copy-link-icon');
const copyLinkTooltip = document.getElementById('copyToolTip');
let timeoutId = null;

//Start of function clicking to copy url

if (copyLinkIcon != null) {

    const hideTooltip = () => {
        copyLinkTooltip.classList.remove('show');
        copyLinkTooltip.setAttribute('aria-hidden', 'true');
        copyLinkIcon.setAttribute('aria-expanded', 'false');
    }

    const showTooltip = () => {
        clearTimeout(timeoutId); // Cancel previous timer
        copyLinkTooltip.classList.add('show');
        copyLinkTooltip.setAttribute('aria-hidden', 'false');
        copyLinkIcon.setAttribute('aria-expanded', 'true');

        // Automatically hide after 2 seconds
        timeoutId = setTimeout(hideTooltip, 2000);
    }

    copyLinkIcon.addEventListener('click', (e) => {
        let copyUrl = copyLinkIcon.getAttribute('data-canonical-link');
        e.stopPropagation();
        showTooltip();
        navigator.clipboard.writeText(copyUrl);
    });
}

//End of function clicking to copy url